/**
 * WorksModelクラス
 */
class WorksModel {
  // ---------------------------------------------------------------------------------------------------------
  // --	WorksModel
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor(baseDir, worksDir, list, finish = null, clear = null)
  {
    // console.log('baseDir:' + baseDir)
    // console.log('worksDir:' + worksDir)

    //共通のディレクトリ
    this.baseDir = baseDir

    //Workごとのパスを設定
    this.works = []
    if(typeof list == 'number')
    {
      for(let i=1; i<=list; i++)
      {
        const path = worksDir + ( '000' + i ).slice( -3 ) + '/'
        this.works.push(path)
      }
    }
    else if(list instanceof Array)
    {
      const len = list.length
      for(let i=0; i<len; i++)
      {
        const path = worksDir + list[i] + '/'
        this.works.push(path)
      }
    }
    // console.log('this.works:', this.works)

    //終了画面
    this.finish = finish

    //クリア演出画面（ほっぷ用）
    this.clear = clear

    //移動コンテンツかどうかのフラグ
    this.isMove = false

    //クラス
    this.moveClass = ''
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default WorksModel
